<template>
  <Breadcrumbs
    title="ASM/FSM wise Sales Report"
    :breadcrumbs="[
      { label: 'Sales', path: '' },
      { label: 'Invoices', path: '/invoice' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <AsmFsmWiseSalesForm />
    </div>
  </div>
</template>

<script>
import AsmFsmWiseSalesForm from './asmfsmwisesales_form.vue';

export default {
  name: 'AsmFsmWiseSalesReport',
  components: {
    AsmFsmWiseSalesForm,
  },
};
</script>

